<template>
  <ScrollList class="activityList" v-if="list.length">
    <div v-for="item in list" :key="item.id" @click="gotoActivity(item, router)" :class="['item', item.showRedPoint && 'withRedPoint after:!top-0 after:!left-[60%]']">
      <Image
        class="size-8 mb-1"
        :src="item.menuLogo">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </Image>
      <div class="w-full truncate font-[700] leading-22 text-11">
        {{ item.activityConfigLogo }}
      </div>
    </div>

    <template #arrowLeft>
      <span class="arrow rotate-180"></span>
    </template>

    <template #arrowRight>
      <span class="arrow"></span>
    </template>
  </ScrollList>
</template>

<script setup lang="ts">
  import type { iActivity } from '@/types/index'
  import ScrollList from '@a/components/ScrollList/index.vue'
  import { gotoActivity } from '@/utils'

  defineProps<{
    list: iActivity[]
  }>()

  const router = useRouter()
</script>

<style lang="scss" scoped>
.activityList{
  @apply h-20.5 pt-4 text-center bgs-[url('@a/views/Home/images/activityList.png'),left_bottom] mt-4;

  .item{
    @apply w-[25%] shrink-0 relative flex-center-col !justify-start snap-start truncate
  }

  .arrow{
    @apply w-4 h-full bgs-[url('@a/views/Home/images/i_arrow_r.png'),center_center,12px] block;
  }

  // .withRedPoint::after{
  //   @apply size-2 rounded-full bg-[#EE0A24] absolute top-0 left-[60%];
  // }
}
</style>
